import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { logger } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
import { forwardRef, lazy, Suspense, useImperativeHandle, useRef } from 'react';
import { useOccConfig } from '../../context/occ/hooks/use-occ-config';
import { CaptchaSkeleton } from './subcomponents/skeleton';
import { CaptchaType } from './types/type';
const GoogleRecaptchaV2 = lazy(() => import('./subcomponents/google-recaptcha-v2/google-recaptcha-v2'));
const b = bemClassBuilder('v-captcha');
const CaptchaBase = (props, forwardedRef) => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { captcha: captchaConfig } = useOccConfig().security;
    const captchaRef = useRef(null);
    useImperativeHandle(forwardedRef, () => ({
        reset: () => { var _a; return (_a = captchaRef.current) === null || _a === void 0 ? void 0 : _a.reset(); }
    }));
    if (!captchaConfig) {
        throw new Error('Cannot render the Captcha component when CAPTCHA is not configured.');
    }
    logger.debug(`Rendering a CAPTCHA instance for action: '${props.action}'.`);
    const loadingIndicator = enableSkeletonLoadingIndicators ? _jsx(CaptchaSkeleton, {}) : null;
    const baseProps = Object.assign(Object.assign({}, props), { ref: captchaRef, className: b.block({ type: captchaConfig.type }, props.className), loadingIndicator });
    const getCaptchaElement = () => {
        switch (captchaConfig.type) {
            case CaptchaType.GoogleRecaptchaV2: {
                return _jsx(GoogleRecaptchaV2, Object.assign({}, baseProps, { config: captchaConfig }));
            }
            default: {
                throw new Error(`Cannot render unsupported Captcha type '${captchaConfig.type}'.`);
            }
        }
    };
    return _jsx(Suspense, { fallback: loadingIndicator, children: getCaptchaElement() });
};
export const Captcha = observer(forwardRef(CaptchaBase));
Captcha.displayName = 'Captcha';
//# sourceMappingURL=captcha.js.map